import { Utils } from "../constants/utils";

export const validations = {
  aadhaar_number: {
    required: "Please enter aadhaar number",
    valid: "Please enter valid aadhaar number",
  },
  address_line_1: {
    required: "Please enter address line1",
  },
  applicant_type: {
    required: "Please enter applicant type",
  },
  annual_income: {
    required: "Please enter annual income",
  },
  business_name: {
    required: "Please enter business name",
  },
  city: {
    required: "Please enter city name",
  },
  company_name: {
    required: "Please enter company name",
  },
  damage_details: {
    required: "Please enter damage details",
    min: "{WORD_LIMIT} characters left",
  },
  dealer_code: {
    required: "Please enter dealer code",
  },
  dob: {
    required: "Please enter date of birth",
    min: "Date of birth should be greater than or equal to",
    max: "Date of birth should be greater than or equal to",
    valid: "Please enter valid date of birth",
  },
  email: {
    required: "Please enter email",
    valid: "Please enter valid email",
  },
  employer_name: {
    required: "Please enter employer name",
  },
  employment_type: {
    required: "Please select employment type",
  },
  ex_showroom_price: {
    required: "Please enter invoice amount",
  },
  mobile: {
    required: "Please enter mobile number",
    valid: "Please enter valid mobile number",
  },
  monthly_salary: {
    required: "Please enter monthly salary",
  },
  name: {
    required: "Please enter name",
    valid:
      "Please enter the full name. If the name has only one word, then repeat it. Eg: Ravi Ravi",
    firstNameMaxLengthPrefix: "First name can not be greater than ",
    firstNameMaxLengthSuffix: " characters",
    lastNameMaxLengthPrefix: "Last name can not be greater than ",
    lastNameMaxLengthSuffix: " characters",
  },
  on_road_price: {
    required: "Please enter estimate amount",
    valid: "Please enter valid (not more than invoice amount) estimate amount",
  },
  pan_number: {
    required: "Please enter pan number",
    valid: "Please enter valid pan number",
  },
  pincode: {
    required: "Please enter pincode",
    valid: `Please enter ${Utils.limit.digits.pincode} digits pincode`,
    noData: "No city and state found for this pincode",
  },
  preferred_date: {
    required: "Please enter preferred date",
    min: `Either current or future date is allowed`,
    max: `Only 30 days as future date is allowed`,
  },
  preferred_timeslot: {
    required: "Please select preferred timeslot",
    valid: `Please select valid preferred timeslot`,
  },
  residence_type: {
    required: "Please select residence type",
  },
  salary_deposit_tenure: {
    required: "Please select salary deposit tenure",
  },
  state: {
    required: "Please enter state name",
  },
  vehicle_category: {
    required: "Please select vehicle category",
  },
  state_id: {
    required: "Please select state",
  },
  city_id: {
    required: "Please select city",
  },
  vehicle_type: {
    required: "Please select vehicle type",
  },
  service_centre_id: {
    required: "Please select service centre",
  },
  title: {
    required: "Please select title",
  },
  work_email: {
    required: "Please enter work email",
    valid: "Please enter valid work email",
  },
};
